import { randomArray } from '@library/common/functions';
import { MockPath } from '@library/common/http/mock-path.mock';

import { Business } from '@library/common/models';
import { MockBusiness } from '@library/common/models/mock';

export const AddressbookRoutes: MockPath<Business>[] = [
   { path: 'ab', verb: 'GET', collection: () => randomArray( MockBusiness )},
   { path: 'ab', verb: 'POST', collection: () => randomArray( MockBusiness )},
   { path: 'ab', verb: 'PATCH', collection: () => randomArray( MockBusiness )},
   { path: 'ab', verb: 'DELETE', collection: () => randomArray( MockBusiness )},
];
